<h2>Seleccionar tipo de Envio</h2>

<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">SR Asociada</span>
  <input id="dni" type="number" class="form-control" aria-label="dni" aria-describedby="inputGroup-sizing-default" [(ngModel)]="et.id_sr" readonly>
</div>

<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Tipo de Envio</span>
  <input type="radio" class="btn-check" name="options-outlined" id="success-outlined" autocomplete="off" checked>
  <label class="btn btn-outline-primary" for="success-outlined" (click)="tipoEnvio(5)">Al Centro</label>
  <input type="radio" class="btn-check" name="options-outlined" id="danger-outlined" autocomplete="off">
  <label class="btn btn-outline-primary" for="danger-outlined" (click)="tipoEnvio(6)">Envio Rapido</label>
</div>
<div class="input-group mb-3" *ngIf="et.id_estado===6">
  <span class="input-group-text" id="inputGroup-sizing-default">Vehiculo</span>
<select class="form-select" aria-label="Select Vehiculo"  [(ngModel)]="et.id_vehiculo">
  <!-- <option selected>Open this select menu</option> -->
  <option *ngFor="let m of vehiculos" value={{m.id}}>{{m.marca +" "+ m.modelo+" ("+m.patente + ") "+ m.detalle}}</option>
  <!-- <div *ngFor="let m of vehiculos">
    <option  value={{m.id}}>{{m.marca +" "+ m.modelo+" ("+m.patente + ") "+ m.detalle}}</option>
  </div> -->
</select>
</div>
<div class="d-grid gap-2 d-md-flex justify-content-md-end">
  <button type="button" class="btn btn-primary" (click)="enviar()" >Continuar</button>
</div>


